import moment from 'moment'

import i18n from '@/i18n/i18n'
import FarmerService from '@/services/admin/FarmerService'
import { build_query, errorMessage } from '@/utilities/helpers.js'

import { FARMER_ERROR_MESSAGES } from '@/constants/errorMessages'

const { t } = i18n.global

export const allowedFilters = [
  'id',
  'retailers.id',
  'has_sales',
  'by_fullname_tckn_phone',
  'by_fullname_tckn_phone_businessnumber',
  'by_company_id',
  'verification_status',
  'has_fullname',
  'has_pending_document_control'
]
export const allowedIncludes = 'retailers,companies'
export const allowedSorts = 'firstname'
export const allowedAppends = 'sum_cash_price,sum_forward_price'

export const namespaced = true

export const state = {
  farmers: null,
  farmer: {},
  meta: null,
  statistics: {},
  gtsData: [],
  gtsSalesHistories: [],
  coupons: [],
  previousGuaranteedApplications: [],
  verificationStatusActivity: null,
  blacklistHistory: [],
  activityHistory: []
}
export const mutations = {
  SET_FARMERS(state, farmers) {
    state.farmers = farmers.data
    state.meta = farmers.meta
  },
  SET_FARMER(state, farmer) {
    state.farmer = farmer
  },
  SET_STATISTICS(state, statistics) {
    state.statistics = statistics
  },
  SET_GTS_DATA(state, data) {
    state.gtsData = data
  },
  SET_GTS_SALES_HISTORIES(state, salesHistories) {
    state.gtsSalesHistories = salesHistories
  },
  SET_COUPONS(state, coupons) {
    state.coupons = coupons
  },
  SET_BLACKLIST_HISTORY(state, history) {
    state.blacklistHistory = history.data
  },
  SET_ACTIVITY_HISTORY(state, history) {
    state.activityHistory = history.data
  },
  ADD_COUPON(state, coupon) {
    state.coupons.push(coupon)
  },
  SET_PREVIOUS_GUARANTEED_APPLICATIONS(state, applications) {
    state.previousGuaranteedApplications = applications
  },
  SET_VERIFICATION_STATUS_ACTIVITY(state, data) {
    state.verificationStatusActivity = data
  },
  UPDATE_FARMER_PHONE_NUMBER(state, data) {
    state.farmer.phone = data.phone
  }
}
export const getters = {
  getFarmerById: state => id => {
    return state.farmers ? state.farmers.find(farmer => farmer.id === id) : false
  }
}
export const actions = {
  getFarmers({ commit, dispatch }, query) {
    query['has_fullname'] = true

    let newQuery = build_query(query, allowedFilters, allowedIncludes, allowedSorts, allowedAppends)

    return new Promise((resolve, reject) => {
      FarmerService.getFarmers(newQuery)
        .then(response => {
          commit('SET_FARMERS', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: FARMER_ERROR_MESSAGES.getFarmersError + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getAllFarmers({ commit, dispatch }, query) {
    let newQuery = build_query(query, allowedFilters, allowedIncludes, allowedSorts, allowedAppends)

    return new Promise((resolve, reject) => {
      FarmerService.getFarmers(newQuery)
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: FARMER_ERROR_MESSAGES.getFarmersError + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getFarmer({ commit, getters, state }, id) {
    if (id == state.farmer.id) return state.farmer

    let farmer = getters.getFarmerById(id)

    if (farmer) {
      commit('SET_FARMER', farmer)
      return farmer
    } else {
      return new Promise(resolve => {
        FarmerService.getFarmer(id).then(response => {
          commit('SET_FARMER', response.data)
          resolve(response.data)
        })
      })
    }
  },
  refreshFarmer({ commit, getters, state }, id) {
    return new Promise(resolve => {
      FarmerService.getFarmer(id)
        .then(response => {
          commit('SET_FARMER', response.data)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  editFarmer({ dispatch, commit }, farmer) {
    return new Promise((resolve, reject) => {
      FarmerService.editFarmer(farmer.id, farmer)
        .then(response => {
          let notification = {}

          if (response.data?.waitingApproval === true) {
            notification = {
              type: 'warning',
              message: t('store.shared.waiting_approval')
            }
          } else {
            commit('SET_FARMER', response.data)
            notification = {
              type: 'success',
              message: t('store.shared.updated', {
                element: t('store.admin.farmers.farmer_info')
              })
            }
          }

          dispatch('notification/add', notification, {
            root: true
          })

          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  sendOtpForUpdatePhoneNumber({ dispatch, commit }, payload) {
    return new Promise((resolve, reject) => {
      FarmerService.sendOtpForUpdatePhoneNumber(payload.farmerId, payload)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('views.admin.farmers.otp_sent')
          }

          dispatch('notification/add', notification, {
            root: true
          })

          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updatePhoneNumber({ dispatch, commit }, payload) {
    return new Promise((resolve, reject) => {
      FarmerService.updatePhoneNumber(payload.farmerId, payload)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          const notification = {
            type: 'danger',
            message: errorMessage(error)
          }

          dispatch('notification/add', notification, {
            root: true
          })

          reject(error)
        })
    })
  },
  checkPhoneNumber({ dispatch, commit }, payload) {
    return new Promise((resolve, reject) => {
      FarmerService.checkPhoneNumber(payload.farmerId, payload)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getFarmerVerificationActivity({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      FarmerService.getFarmerVerificationActivity(id)
        .then(response => {
          commit('SET_VERIFICATION_STATUS_ACTIVITY', response.data)

          resolve(response.data)
        })
        .catch(err => {
          const notifications = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notifications, {
            root: true
          })
          reject(err)
        })
    })
  },
  updateFarmerCksStatus({ dispatch, commit }, payload) {
    return new Promise((resolve, reject) => {
      FarmerService.updateFarmerCksStatus(payload.farmerId, payload)
        .then(response => {
          commit('SET_FARMER', response.data)

          const notification = {
            type: 'success',
            message: t('store.admin.farmers.update_farmer_cks_status_success')
          }

          dispatch('notification/add', notification, {
            root: true
          })

          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getStatistics({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      FarmerService.getStatistics(id)
        .then(response => {
          commit('SET_STATISTICS', response.data)

          resolve(response.data)
        })
        .catch(err => {
          const notifications = {
            type: 'danger',
            message: FARMER_ERROR_MESSAGES.getStatisticsError + errorMessage(err)
          }
          dispatch('notification/add', notifications, {
            root: true
          })
          reject(err)
        })
    })
  },
  getGtsData({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      FarmerService.getGtsData(id)
        .then(response => {
          commit('SET_GTS_DATA', response.data.gts_data)
          commit('SET_GTS_SALES_HISTORIES', response.data.gts_sales_histories)

          resolve(response.data)
        })
        .catch(err => {
          const notifications = {
            type: 'danger',
            message: FARMER_ERROR_MESSAGES.getGtsDataError + errorMessage(err)
          }
          dispatch('notification/add', notifications, {
            root: true
          })
          reject(err)
        })
    })
  },
  checkGtsData({ dispatch }, id) {
    return new Promise((resolve, reject) => {
      FarmerService.checkGtsData(id)
        .then(response => {
          const notifications = {
            type: 'info',
            message: t('store.admin.farmers.fetching_gts_data_please_wait')
          }
          dispatch('notification/add', notifications, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notifications = {
            type: 'danger',
            message: FARMER_ERROR_MESSAGES.getGtsDataError
          }

          if (err.response.status == 409) {
            notifications.message += t('store.admin.farmers.may_a_search_is_working_for_the_farmer_already')
          }

          dispatch('notification/add', notifications, {
            root: true
          })
          reject(err)
        })
    })
  },
  getCoupons({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      FarmerService.getCoupons(id)
        .then(response => {
          commit('SET_COUPONS', response.data)
          resolve(response.data)
        })
        .catch(err => {
          const notifications = {
            type: 'danger',
            message: FARMER_ERROR_MESSAGES.getCouponsError + errorMessage(err)
          }
          dispatch('notification/add', notifications, {
            root: true
          })
          reject(err)
        })
    })
  },
  removeCoupon({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      FarmerService.removeCoupon(params.id, state.farmer.id)
        .then(response => {
          commit('SET_COUPONS', response.data)
          const notifications = {
            type: 'success',
            message: t('store.shared.removed', {
              element: t('store.admin.farmers.coupon')
            })
          }
          dispatch('notification/add', notifications, {
            root: true
          })
          resolve(response.data)
        })
        .catch(err => {
          const notifications = {
            type: 'danger',
            message: FARMER_ERROR_MESSAGES.removeCouponError + errorMessage(err)
          }
          dispatch('notification/add', notifications, {
            root: true
          })
          reject(err)
        })
    })
  },
  checkPolicyAcceptance({ dispatch }, params) {
    return new Promise((resolve, reject) => {
      FarmerService.checkPolicyAcceptance(params.tckn, params.phone)
        .then(response => {
          if (params.resend) {
            const notification = {
              type: 'success',
              message: t('store.shared.send', {
                element: t('store.admin.farmers.otp')
              })
            }
            dispatch('notification/add', notification, {
              root: true
            })
          }
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: params.resend
              ? t('store.admin.farmers.an_error_occurred_while_sending_otp') + errorMessage(err)
              : t('store.admin.farmers.an_error_occurred_during_privacy_policy_check') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  verifyPolicyAcceptance({ dispatch }, params) {
    return new Promise((resolve, reject) => {
      FarmerService.verifyPolicyAcceptance(params.tckn, params.code)
        .then(response => {
          if (response.data.is_verified) {
            resolve(response.data)
          } else {
            const notification = {
              type: 'danger',
              message: t('store.retailer.farmer.invalid_confirmation_code')
            }
            dispatch('notification/add', notification, {
              root: true
            })
            reject(response.data)
          }
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getPreviousGuaranteedApplications({ commit, dispatch }, application) {
    let newQuery = build_query(
      {
        'filter[beforeCreated]': moment(application.created_at).format('YYYY-MM-DD HH:mm'),
        'filter[status]': '1,2,3,4,5,6',
        per_page: 1000
      },
      ['farmer'],
      'order,order.payments,order.payments.collections,decisions,score',
      ['-created_at'],
      ['last_decision']
    )

    return new Promise((resolve, reject) => {
      FarmerService.getPreviousGuaranteedApplications(application.farmer_id, newQuery)
        .then(response => {
          commit('SET_PREVIOUS_GUARANTEED_APPLICATIONS', response.data)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.farmers.an_error_occurred_while_getting_vouched_applications') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  checkGdprConsentDocumentByFarmerId({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      FarmerService.checkGdprConsentDocumentByFarmerId(id)
        .then(response => {
          if (!response || !response.document) {
            resolve(null)
          }
          resolve(response.document)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  downloadGdprDocument({ commit, dispatch }, gdprConsentDocument) {
    return new Promise((resolve, reject) => {
      FarmerService.downloadGdprDocument(gdprConsentDocument.id)
        .then(response => {
          let fileURL = window.URL.createObjectURL(new Blob([response]))
          let fileLink = document.createElement('a')

          fileLink.href = fileURL
          fileLink.setAttribute('download', gdprConsentDocument.document)
          document.body.appendChild(fileLink)

          fileLink.click()
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  removePreApprovedLimit({ dispatch, commit }, payload) {
    return new Promise((resolve, reject) => {
      FarmerService.removePreApprovedLimit(payload.farmerId, payload)
        .then(response => {
          commit('SET_FARMER', response.data)

          const notification = {
            type: 'success',
            message: t('store.admin.farmers.removed_pre_approved_limit_successfully')
          }

          dispatch('notification/add', notification, {
            root: true
          })

          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getBlacklistHistory({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      FarmerService.getBlacklistHistory(id)
        .then(response => {
          commit('SET_BLACKLIST_HISTORY', response)
          resolve(response)
        })
        .catch(err => {
          const notifications = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notifications, {
            root: true
          })
          reject(err)
        })
    })
  },
  getActivityHistory({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      FarmerService.getActivityHistory(id)
        .then(response => {
          commit('SET_ACTIVITY_HISTORY', response)
          resolve(response)
        })
        .catch(err => {
          const notifications = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notifications, {
            root: true
          })
          reject(err)
        })
    })
  },
  inactivatePhoneNumber({ dispatch, commit }, id) {
    return new Promise((resolve, reject) => {
      FarmerService.inactivatePhoneNumber(id)
        .then(response => {
          commit('UPDATE_FARMER_PHONE_NUMBER', response.data)

          const notification = {
            type: 'success',
            message: t('store.admin.farmers.phone_number_inactivated')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
